
import { computed } from '@vue/composition-api';
import type { Breadcrumb } from '~/type/Breadcrumb';
interface Props {
  rootIcon: boolean;
  isLastLinkActive?: boolean;
  list: Breadcrumb[];
  size?: 'middle' | 'small';
  shrinkOnMobile?: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  rootIcon: {
    key: "rootIcon",
    required: false,
    type: Boolean,
    default: true
  },
  isLastLinkActive: {
    key: "isLastLinkActive",
    required: false,
    type: Boolean,
    default: false
  },
  list: {
    key: "list",
    required: true,
    type: Array
  },
  size: {
    key: "size",
    required: false,
    type: String,
    default: 'middle'
  },
  shrinkOnMobile: {
    key: "shrinkOnMobile",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const formatList = computed(() => {
    return props.isLastLinkActive ? props.list.length : props.list.length - 1;
  });
  const structuredList = computed(() => {
    return props.list.map((el, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': el.name,
      'item': process.env.projectURL + el.url
    }));
  });
  return {
    formatList,
    structuredList
  };
};
export default __sfc_main;
